import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/index";
import { TransactionalSubheader } from "iuvity-ui-components/dist/transactionalsubheader";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { TabView } from "iuvity-ui-components/dist/tabview";
import { Header } from "../../components";
import { RolesAdminComponent } from "../../components/roles/RolesAdminComponent";
import { useRoles } from "../../hooks/useRoles";

export const AdminRolesPage = () => {
    const navigate = useNavigate();
    const {
        t,
        appState: { user, activeIndexRoles },
        setAppState,
    } = useContext(AppContext);

    // Esta lógica se aplica por la reutilización de la página
    // de Detalle del Rol, en el botón de detalle de AdminUsers
    useEffect(()=>{
        setAppState((prev:any)=>({
            ...prev,
            selectedRolesObject: {
                ...prev.selectedRolesObject,
                tenantName: undefined,
                cameFromRolesPage: undefined,
            }
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    const { data, rolesAction, reloadFn } = useRoles("DATA");
    const [activeIndex, setActiveIndex] = useState<number>(activeIndexRoles || 0);

    return (
        <>
            {/* <Header
                welcomeMessage={t("Dashboard.welcomeTitle")}
                userName={user?.name}
            /> */}
            <TransactionalSubheader
                subheaderTitle={
                <div
                    style={{
                    position: "relative",
                    left: "-4rem",
                    }}
                >
                    <span>{t("Roles.rolesTitle")}</span>
                </div>
                }
            >
                <TransactionalSubheader.BreadCrumb
                id={t("Roles.rolesTitle")}
                disabledDefaultHome={true}
                breadcrumbsHomeItem={{
                    icon: "iu iu-icon-home",
                    command: () => navigate("/"),
                }}
                breadcrumbsItems={[
                    {
                        label: t("ConsoleTranslations.accessControlBreadcrumbs"),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                    {
                        label: t("Roles.rolesManagementBreadcrumbs"),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                ]}
                style={{
                    paddingLeft: '0',
                }}
                />
                <TransactionalSubheader.Title />
            </TransactionalSubheader>

            <BoxFull className="px-0 py-0" style={{ marginTop: "40px" }} variant="tertiary">
                <div
                    className="catalogue__description"
                    style={{
                        fontFamily: "var(--fontBarlowRegular)",
                        fontSize: "var(--font-size-md)",
                        color: "var(--cardBackgroundColorOneShade80)",
                    }}
                >
                    <span dangerouslySetInnerHTML={{ __html: t("Roles.rolesAdminDescription") }} style={{ lineHeight: 'var(--space-m)' }} />
                </div>
                <TabView
                    className="upload-tabview mt-4"
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        setActiveIndex(e.index);
                        setAppState((prev) => ({
                            ...prev,
                            activeIndexRoles: e.index,
                        }));
                    }}
                    items={[
                        {
                            key: "1",
                            header: t("Roles.availableTabTitle"),
                            children:
                                <RolesAdminComponent
                                    data={data}
                                    rolesAction={rolesAction}
                                    reloadFn={reloadFn}
                                />,
                        },
                        {
                            key: "2",
                            header: t("Roles.deletedTabTitle"),
                            children:
                                <RolesAdminComponent
                                    data={data}
                                    rolesAction={rolesAction}
                                    reloadFn={reloadFn}
                                    isDeleteComponent
                                />,
                        },
                    ]}
                />
            </BoxFull>
        </>
    )
}